// @ts-check

import {
  customerCareEmail,
  service as serviceConstants
} from '@/core/constants'

const { OY, UKKOPRO, TLP } = serviceConstants

const breakpoint = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1500
}

/** @returns {AppModuleState} */
export const initAppState = () => ({
  service: process.env.VUE_APP_SERVICE,
  environment: process.env.VUE_APP_ENV,
  width: window.innerWidth,
  height: window.innerHeight,
  ua: navigator.userAgent,
  trustpilot: process.env.VUE_APP_TRUSTPILOT_ENABLED === 'true',
  googleTagManager: !!process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID
})

/** @type {AppGetterTree} */
export const appGetters = {
  isTmiService({ service }) {
    return service === UKKOPRO
  },
  isTlpService({ service }) {
    return service === TLP
  },
  isKyyService({ service }) {
    return service === TLP
  },
  isOyService({ service }) {
    return service === OY
  },
  isEntrepreneur({ service }) {
    return service === UKKOPRO || service === OY
  },
  isLightEntrepreneur({ service }) {
    return service === TLP
  },
  isSandbox({ environment }) {
    return environment === 'sandbox'
  },
  serviceCustomerCareEmail({ service }) {
    return customerCareEmail[service]
  },
  isXs() {
    return true
  },
  isSm({ width }) {
    return width >= breakpoint.sm
  },
  isMd({ width }) {
    return width >= breakpoint.md
  },
  isLg({ width }) {
    return width >= breakpoint.lg
  },
  isXl({ width }) {
    return width >= breakpoint.xl
  },
  is2xl({ width }) {
    return width >= breakpoint.xxl
  },
  isTrustPilotEnabled({ trustpilot }) {
    return trustpilot
  }
}

/** @type {AppMutationTree} */
export const appMutations = {
  setDimensions(state, { width, height }) {
    state.width = width
    state.height = height
  }
}

export const appModule = {
  namespaced: true,
  state: initAppState,
  getters: appGetters,
  mutations: appMutations
}

export default appModule
